import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid2,
  Paper,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import Header from "../../components/Header";
import { Delete, Edit, SaveAlt } from "@mui/icons-material";
import { tokens } from "../../theme";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { useEffect, useMemo, useState } from "react";
import { MenuItem } from "react-pro-sidebar";
import MenuItemMui from "@mui/material/MenuItem";
import axios from "axios";
import { DATA_SAVE_URL } from "../utils/UrlHandle";
import NotificationToaste from "../global/NotificationToaste";
import { LAB_TEST_DEFAULT_VALUE } from "./NewTestUtils";
import { getPayload, setPostPayload, setPutPayload } from "../../services/api";

const NewTest = () => {
  const [data, setData] = useState([]);
  const [labTestData, setLabTestData] = useState(LAB_TEST_DEFAULT_VALUE);
  const [category, setCategory] = useState([]);
  //should be memoized or stable
  const columns = useMemo(
    () => [
      {
        accessorKey: "testName",
        header: "Test Name",
        size: 200,
      },
      {
        accessorKey: "estimatedTime", //normal accessorKey
        header: "Estimated Days",
        size: 80,
      },
      {
        accessorKey: "description", //normal accessorKey
        header: "Description",
        size: 80,
      },
      {
        accessorFn: (row) =>
          `${row.amount.toLocaleString(undefined, {
            minimumFractionDigits: 2,
          })}`,
        header: "Amount",
        size: 100,
        muiTableBodyCellProps: {
          align: "right",
        },
      },
    ],
    []
  );
  const table = useMaterialReactTable({
    columns,
    data,
    enableRowActions: true,
    positionActionsColumn: "last",

    initialState: {
      density: "compact",
      pagination: { pageSize: 25, pageIndex: 0 },
    },

    muiPaginationProps: {
      rowsPerPageOptions: [25, 50, 100, 150, 200],
      showFirstButton: true,
      showLastButton: true,
    },

    muiTableBodyRowProps: ({ row }) => ({
      //conditionally style expanded rows
      sx: { padding: "10px" },
    }),

    renderRowActionMenuItems: ({ closeMenu, row }) => [
      <MenuItem
        sx={{ padding: "10px" }}
        key={1}
        onClick={() => {
          handleLoadEditData(row.original);
          closeMenu();
        }}
      >
        <Button variant="text" fullWidth startIcon={<Edit />}>
          <Typography variant="subtitle1">Edit</Typography>
        </Button>
      </MenuItem>,
      <MenuItem key={2}>
        <Button variant="text" fullWidth startIcon={<Delete />}>
          <Typography variant="subtitle1">Delete</Typography>
        </Button>
      </MenuItem>,
    ],
  });

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [update, setUpdate] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState();
  const [messageType, setMessageType] = useState();
  const [loading, setLoading] = useState(true);

  const handleSaveData = () => {
    console.log(labTestData);
    // if (labTestData.category.category === "") {
    //   setLabTestData((pre) => ({
    //     ...pre,
    //     category: {
    //       ...pre.category,
    //       error: true,
    //     },
    //   }));
    //   return;
    // } else
    if (labTestData.testName.testName === "") {
      setLabTestData((pre) => ({
        ...pre,
        testName: {
          ...pre.testName,
          error: true,
          helperText: "Enter test name.",
        },
      }));
      return;
    } else {
      setLabTestData((pre) => ({
        ...pre,
        testName: {
          ...pre.testName,
          error: false,
          helperText: "",
        },
        category: {
          ...pre.category,
          error: false,
          helperText: "",
        },
      }));
    }
    if (labTestData.amount.amount === "" || labTestData.amount.amount <= 0) {
      setLabTestData((pre) => ({
        ...pre,
        amount: {
          ...pre.amount,
          error: true,
          helperText: "Enter amount.",
        },
      }));
      return;
    } else {
      setLabTestData((pre) => ({
        ...pre,
        amount: {
          ...pre.amount,
          error: false,
          helperText: "",
        },
      }));
    }
    handleFormSubmit();
  };

  const handleFormSubmit = async () => {
    if (update) {
      const sendData = {
        id: labTestData.id,
        testName: labTestData.testName.testName,
        amount: labTestData.amount.amount,
        sampleType: labTestData.sampleType.sampleType,
        estimatedTime: labTestData.estimatedTime.estimatedTime,
        description: labTestData.description.description,
        category: { id: labTestData.category.category },
      };

      setLoading(true);

      await setPutPayload
        .setPayloadData(DATA_SAVE_URL + "/api/v1/labtest", sendData)
        .then(function (response) {
          loadBasicData();
          setMessage("Data Updated successfully..!");
          setMessageType("success");
          setOpen(true);
          setLoading(false);

          //Reset data
          resetFieldDat();
        })
        .catch(function (error) {
          console.log(error);
          setMessage(error);
          setMessageType("error");
          setOpen(true);
          setLoading(false);
        });
      setUpdate(false);
    } else {
      const sendData = {
        testName: labTestData.testName.testName,
        amount: labTestData.amount.amount,
        sampleType: labTestData.sampleType.sampleType,
        estimatedTime: labTestData.estimatedTime.estimatedTime,
        description: labTestData.description.description,
        category: { id: labTestData.category.category },
      };

      setLoading(true);
      await setPostPayload
        .setPayloadData(DATA_SAVE_URL + "/api/v1/labtest", sendData)
        .then(function (response) {
          loadBasicData();
          setMessage("Data Updated successfully..!");
          setMessageType("success");
          setOpen(true);
          setLoading(false);

          //Reset data
          resetFieldDat();
        })
        .catch(function (error) {
          console.log(error);
          setMessage(error);
          setMessageType("error");
          setOpen(true);
          setLoading(false);
        });
    }
  };

  const handleLoadEditData = async (data) => {
    setLoading(true);

    await getPayload
      .getPayloadData(DATA_SAVE_URL + "/api/v1/labtest/" + data.id)
      .then(function (response) {
        setUpdate(true);
        console.log("this is data : ", response.data);
        setLabTestData((pre) => ({
          ...pre,
          id: response.data.id,
          testName: {
            ...pre.testName,
            testName: response.data.testName,
          },
          category: {
            ...pre.category,
            category: response.data.category.id,
          },
          description: {
            ...pre.description,
            description: response.data.description,
          },
          sampleType: {
            ...pre.sampleType,
            sampleType: response.data.sampleType,
          },
          estimatedTime: {
            ...pre.estimatedTime,
            estimatedTime: response.data.estimatedTime,
          },
          amount: {
            ...pre.amount,
            amount: response.data.amount,
          },
        }));
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setMessage(error);
        setMessageType("error");
        setOpen(true);
        setLoading(false);
      });
  };

  const resetFieldDat = () => {
    setLabTestData({
      id: "",
      testName: {
        testName: "",
        helperText: "",
        error: false,
      },
      category: {
        category: "",
        helperText: "",
        error: false,
      },
      description: {
        description: "",
        helperText: "",
        error: false,
      },
      sampleType: {
        sampleType: "",
        helperText: "",
        error: false,
      },
      estimatedTime: {
        estimatedTime: "",
        helperText: "",
        error: false,
      },
      amount: {
        amount: "",
        helperText: "",
        error: false,
      },
      active: true,
    });
  };

  useEffect(() => {
    loadBasicData();
    return () => loadBasicData;
  }, []);

  const loadBasicData = async () => {
    await getPayload
      .getPayloadData(DATA_SAVE_URL + "/api/v1/labtest/all")
      .then(function (response) {
        // console.log("ss", response.data.category);
        setData(response.data.allTests);
        setCategory(response.data.category);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleCloseToaste = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {loading ? (
        <CircularProgress
          sx={{
            color: colors.greenAccent[500],
            position: "absolute",
            zIndex: 10,
          }}
        />
      ) : (
        ""
      )}
      <Paper
        sx={{
          width: "70%",
          padding: "10px",
          borderRadius: "8px",
          marginBottom: "15px",
        }}
        elevation={3}
      >
        <Header
          title="Laboratory Test"
          subtitle="Add/Update/Delete test list"
        />
        <Divider sx={{ marginBottom: "15px" }} />

        <Grid2 container spacing={1}>
          <Grid2 size={4}>
            <TextField
              select
              label="Category"
              fullWidth
              size="small"
              error={labTestData.category.error}
              onChange={(e) =>
                setLabTestData((pre) => ({
                  ...pre,
                  category: {
                    ...pre.category,
                    category: e.target.value,
                  },
                }))
              }
              value={labTestData?.category?.category}
            >
              {category?.map((option) => (
                <MenuItemMui key={option.id} value={option.id}>
                  {option.category}
                </MenuItemMui>
              ))}
            </TextField>
          </Grid2>
          <Grid2 size={6}>
            <TextField
              fullWidth
              variant="outlined"
              type="text"
              label="Test Name"
              size="small"
              error={labTestData.testName.error}
              helperText={labTestData.testName.helperText}
              value={labTestData.testName.testName}
              sx={{
                gridColumn: "span 2",
              }}
              onChange={(e) =>
                setLabTestData((pre) => ({
                  ...pre,
                  testName: { ...pre.testName, testName: e.target.value },
                }))
              }
            />
          </Grid2>
          <Grid2 size={2}>
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              label="Amount"
              size="small"
              error={labTestData.amount.error}
              helperText={labTestData.amount.helperText}
              value={labTestData.amount.amount}
              name="ins_code"
              sx={{
                gridColumn: "span 2",
              }}
              onChange={(e) =>
                setLabTestData((pre) => ({
                  ...pre,
                  amount: {
                    ...pre.amount,
                    amount: e.target.value,
                  },
                }))
              }
              slotProps={{
                input: { min: 0 },
              }}
            />
          </Grid2>
          <Grid2 size={3}>
            <TextField
              fullWidth
              variant="outlined"
              type="text"
              label="Sample Detail"
              size="small"
              value={labTestData.sampleType.sampleType}
              name="ins_code"
              sx={{
                gridColumn: "span 2",
              }}
              onChange={(e) =>
                setLabTestData((pre) => ({
                  ...pre,
                  sampleType: {
                    ...pre.sampleType,
                    sampleType: e.target.value,
                  },
                }))
              }
            />
          </Grid2>
          <Grid2 size={3}>
            <TextField
              fullWidth
              variant="outlined"
              type="text"
              label="Estimated Days"
              size="small"
              value={labTestData.estimatedTime.estimatedTime}
              sx={{
                gridColumn: "span 2",
              }}
              onChange={(e) =>
                setLabTestData((pre) => ({
                  ...pre,
                  estimatedTime: {
                    ...pre.estimatedTime,
                    estimatedTime: e.target.value,
                  },
                }))
              }
            />
          </Grid2>
          <Grid2 size={6} textAlign="right">
            <TextField
              fullWidth
              variant="outlined"
              type="text"
              label="Description"
              size="small"
              value={labTestData.description.description}
              name="ins_code"
              sx={{
                gridColumn: "span 2",
              }}
              onChange={(e) =>
                setLabTestData((pre) => ({
                  ...pre,
                  description: {
                    ...pre.description,
                    description: e.target.value,
                  },
                }))
              }
            />
          </Grid2>
          <Grid2 size={12} textAlign="right">
            <Button
              type="submit"
              disabled={loading}
              color="secondary"
              startIcon={<SaveAlt />}
              variant="contained"
              sx={{ height: "70%", width: "100px", marginTop: "10px" }}
              onClick={handleSaveData}
            >
              {update === true ? "Update" : "Save"}
            </Button>
          </Grid2>
        </Grid2>
      </Paper>
      <Box flexGrow={1} sx={{ width: "70%" }}>
        <Grid2 container spacing={1}>
          <Grid2 size={12}>
            <Paper
              sx={{
                padding: "15px",
                borderRadius: "8px",
              }}
              elevation={3}
            >
              <Header title="View All" subtitle="Update / Delete " />
              <MaterialReactTable table={table} />
            </Paper>
          </Grid2>
        </Grid2>
      </Box>
      <NotificationToaste
        handleCloseToaste={handleCloseToaste}
        open={open}
        message={message}
        messageType={messageType}
      />
    </Box>
  );
};

export default NewTest;
